import React from "react";
import "./FilterTags.css";

const FilterTags = ({ categories, selected, onSelect }) => {
  return (
    <div className="filters-wrapper">
      <h2 className="filters-title">BSON YAZILAR</h2>
      <div className="filters-buttons">
        {["Hepsi", ...categories].map((cat, index) => (
          <button
            key={index}
            className={selected === cat ? "active" : ""}
            onClick={() => onSelect(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
    </div>

  );
};

export default FilterTags;
